import { app } from 'actions/app'
import { contacts } from 'actions/contacts'
import { useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useAppSelector } from 'shared/hooks'

export function useMenuHandlers() {
	const navigate = useNavigate()
	const { id } = useParams<{ id?: string }>()
	const campaign = useAppSelector(state => state.campaign)
	const leftSide = useAppSelector(state => state.leftSideMenu.leftSide)
	const active = useAppSelector(state => state.leftSideMenu.active)

	const bottomListActiveHandler = useCallback((item: any) => {
		if (leftSide.type === 'account') {
			return
		}
		if (id) {
			if (campaign.archive && item.link === '/archive') {
				return 'active semi-bold'
			}
			if (!campaign.archive && item.link === '/campaigns') {
				const campaign = leftSide.list?.find(item => item.id === id)
				return !campaign ? 'active semi-bold' : ''
			}
		} else {
			return active === item.id ? 'active semi-bold' : ''
		}
	}, [id, campaign, leftSide.list, leftSide.type, active])

	const clickOnLink = useCallback((item: { id: string }) => {
		app.changeActiveItem(item.id)
		contacts.changeContactsPage(0)
		navigate(`/campaigns/${item.id}`)
	}, [navigate])

	return {
		active,
		bottomListActiveHandler,
		clickOnLink,
		leftSide
	}
}
